import {Injectable} from '@angular/core';
import {LargeMessageInput} from "../interfaces/large-message-input";
import {LargeMessageTheme} from "../enums/large-message-theme";
import {OverlayService} from "../overlay/overlay.service";
import {LargeMessageComponent} from "../shared/large-message/large-message.component";

@Injectable({
  providedIn: 'root'
})
export class LargeMessageService {

  constructor(private overlayService: OverlayService) { }

  showLargeMessage(inputData: LargeMessageInput): number {
    inputData = this.validateInputData(inputData);

    return this.overlayService.addComponent({
      component: LargeMessageComponent,
      data: {
        data: inputData
      }
    });
  }

  validateInputData(inputData: LargeMessageInput): LargeMessageInput {
    if(inputData.theme === undefined) {
      inputData.theme = LargeMessageTheme.GOLD;
    }

    return inputData;
  }
}
